import axios from 'axios';
import { authorizationsQuery, authorizationsLoginQuery } from './GQLQueries';

const getPermissions = async (
  graphQlHubServiceUrl,
  applicationResourceName
) => {
  const response = await axios.post(graphQlHubServiceUrl, {
    query: authorizationsQuery,
    variables: { resources: applicationResourceName }
  });

  return response.data.data.authorizations.map(
    authorization => authorization.permission
  );
};

const getLoginEnabled = async graphQlHubServiceUrl => {
  const response = await axios.post(graphQlHubServiceUrl, {
    query: authorizationsLoginQuery
  });

  return !response.data.data.loginEnabled.isLocked;
};

export { getPermissions, getLoginEnabled };



// WEBPACK FOOTER //
// ./src/apis/AuthZApi.js